export default __webpack_public_path__ + "static/media/229.066a9c36.jpg";